export type Series = 'training' | 'season_1' | 'infinite'

export const SeriesId: { [P in Series]: number } = {
  training: 0,
  season_1: 1,
  infinite: 2,
}

export interface ISession {
  user: IUser
  quest: IQuest
  record: {
    done_tracts: number,
    answers_count: number,
  }
  levels: ILevel[]
  series_done: boolean
  series_name: Series,
  series_stat: { [P in Series]: { done: boolean } }
  extra_tracts: { [tract_id: string]: [number, number, number][][] }
  campaigns: ICampaign[]
}

interface IMedal {
  count: number
  image: string | { [locale: string]: string } // campaign.i18n ? { [locale:string]: string } : string
  mask_image?: string
  name?: {
    en: string
    ja: string
  },
}

export interface ICampaign {
  id: number,
  name: { [local: string]: string }
  count: number
  period_begin: number
  period_end: number
  medals: IMedal[]
  type: string
  done_message?: { [locale: string]: string }
  i18n: boolean
}

export interface IUser {
  id: number
  email: string
  nickname: string
  locale: string
  gravatar_public: boolean
  gravatar_private: boolean
  personal_setting?: IPersonalSetting
  password_is_set: boolean
}

export interface IPersonalSetting {
  show_startup_hint: boolean
}

export interface IQuest {
  id: number
  level: ILevel
  tract_id: number
  galaxies: IGalaxy[]
  answers: IAnswer[]
  created_at: string
  tract_index: number
}

export interface ILevel {
  stamp_name: string
  series_id: number
  en_name: string
  ja_name: string
  id: number
  layer: 'dud' | 'wide'
  num_goods: number
  num_tracts: number
  tract_ids_for_user?: number[]
}

export interface ICaptainAnswer extends IAnswer {
  comment?: string
  comment_en?: string
}

export interface IGalaxy {
  id: string
  ra: number
  dec: number
  captain_answer?: ICaptainAnswer
}

export interface IAnswer {
  id: string
  galaxy_id: string
  galaxy_type: 'spiral' | 'elliptical' | 'not_sure'
  in_interaction: 'yes' | 'no' | 'not_sure'
  ring: boolean
  fan: boolean
  tail: boolean
  distorted: boolean
}

export interface IMessage {
  id: number
  ja_title: string
  en_title: string
  ja_html: string
  en_html: string
  published_at: string
}

export interface IPresent202101 {
  name: string
  zip_code: string
  address1: string
  address2: string
  address3: string
  country_code: number
  message: string
}

export interface IPresent202201 {
  name: string
  zip_code: string
  address1: string
  address2: string
  address3: string
  country_code: number
  message: string
}
